import { useState, useEffect } from 'react';
import { GurupassClient } from '@gurupass/sdk';
import { getGurupassClient } from '@/services/gurupass-api-client';
import { getItemStorage } from '@/services/storage';

export function useGlobalGurupassClient() {
	const [client, setClient] = useState<GurupassClient | null>(null);
	const [clientIsLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const initializeClient = () => {
			// Verificar se estamos no browser e se há token
			if (typeof window !== 'undefined') {
				const token = getItemStorage('gurupass:token');
				if (token) {
					const gurupassClient = getGurupassClient();
					setClient(gurupassClient);
				}
			}
			setIsLoading(false);
		};

		initializeClient();
	}, []);

	return { client, clientIsLoading };
}
